module.exports = __webpack_public_path__ + "img/pumpkin.50ad4b50.jpg";